export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: {
        user_name: '',
        password: '',
        currentMenu: 1
      }
    };
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
    doSubmit() {
      this.$emit('doSubmit', this.model);
    }
  }
};